export const parameters = {
	serviceUrl: 'https://api-itp2-prod-za.azure-api.net/bl',
	captchaKey: '6LeeTsMrAAAAANEOVxC4fMXdXZX2yzABk9SdvhsA',
	brandLabelSubscriptionKey: 'af00ff8dcc3042bd84feddadac128eb0',
	bitpUrl: 'https://web-admin-itp2-prod-za.azurewebsites.net',
	environment: '',
	appInsightsConnectionString: 'InstrumentationKey=96ea614b-30f6-4b00-82f8-30c1d41f700c;IngestionEndpoint=https://southafricanorth-0.in.applicationinsights.azure.com/;LiveEndpoint=https://southafricanorth.livediagnostics.monitor.azure.com/;ApplicationId=7a853895-c359-4733-807c-0efd8e654908'

	// serviceUrl: 'http://localhost:7071',
	// serviceUrl: 'https://briisk-i-dev-api.azure-api.net/bl',
	// captchaKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
	// brandLabelSubscriptionKey: '6aeeca623d274b61bd75b25cd28d2cb8',
	// bitpUrl: 'https://briisk-i-dev-web.azurewebsites.net',
	// environment: 'dev',
	// appInsightsConnectionString: ''
};
